export const getYotoIconUrlFromMediaId = (mediaId: string): string => {
  return `https://media-secure-v2.api.yotoplay.com/icons/${mediaId.replace("yoto:#", "")}`;
};
